var money_format = $('body').data('money-format');

$(document).ready(function () {

    if ($('.pdp-main-wrapper').length > 0 && $('.custom-discount-price').length > 0){
        
        clearPayPriceUpdate();
        $(document).on('change', `.pdp-main-wrapper .product-form__input--dropdown .select__select`, function(){
          
          if($('.shopify-app-block square-placement').length > 0){
            var app_block = $('.shopify-app-block square-placement');
            if(app_block[0].shadow && app_block[0].brandNameLower == "clearpay"){
                setTimeout(function(){
                  clearPayPriceUpdate();
                }, 1500)
            }
          }
          
        });
    }

    $(document).on('click', `.gnatta-chat-now`, function(event){
      $('.gnattaChat #gwc-chatAvailable').trigger('click');
    })
  
    if($('.app-download-page').length > 0){
      const wishlistInterval = setInterval(function () {
        if($('.wishlist-fix.wishlist-page-widget').length > 0){
          $('.wishlist-fix.wishlist-page-widget').css('display', 'none')
          clearInterval(wishlistInterval);
        }
      }, 200);
    }


    $(document).on('click', `a.primary-btn.disabled`, function(event){
      event.preventDefault();
    });

     $(document).on('click', `#read-more`, function(){
      var _this = $(this);
      var full_content = _this.parents('.read-more-less-content').siblings('input#read-more-less-input').attr('data-full-des')
      var less_content = _this.parents('.read-more-less-content').siblings('input#read-more-less-input').attr('data-less-des')
      _this.parents('.read-more-less-content').html(full_content)
      
    });
    $(document).on('click', `#read-less`, function(){
      var _this = $(this);
      var full_content = _this.parents('.read-more-less-content').siblings('input#read-more-less-input').attr('data-full-des')
      var less_content = _this.parents('.read-more-less-content').siblings('input#read-more-less-input').attr('data-less-des')
      _this.parents('.read-more-less-content').html(less_content)
      
    });

    $(document).on('click', `.bottom-links .quick-add-to-cart`, function(){
      var _this = $(this);
      var  variant_id = parseFloat(_this.parents('.bottom-links').siblings('#card_product_info').attr('data-variant'));
      var  product_handle = [];
      var  product_data = JSON.parse(_this.parents('.bottom-links').siblings('#card_product_info').attr('data-product'));
      product_handle.push(product_data.handle)
      var qty = 1;
      const item = {
        quantity: qty,
        id: variant_id
      };
      
      if (_this.attr('data-tribe')) {
        item.properties = { warriorTribe: 'WarriorTribe' };
      }
      
      const data = { items: [item] };
      ajaxCart(data, 'quickAdd', _this, product_handle);
    });

    
    $(document).on('click', `.bottom-links .quick-buy-modal`, function(){
      var _this = $(this);
      var handle = '';
      if($('#collection_handle')){
        handle = '/collections/'+$('#collection_handle').data('handle');
      }

      $('.quick-buy-modal-block .modal-detail .offer-info').addClass('hidden');
      var product_data = JSON.parse(_this.parents('.bottom-links').siblings('#card_product_info').attr('data-product'));
      var discount_message = "";
      if(_this.parents('.bottom-links').siblings('.top-content').find('.offer-info.discount-message').length > 0){
        discount_message = _this.parents('.bottom-links').siblings('.top-content').find('.offer-info.discount-message p').html();
      }
      
      var product_discount = 0;
      if(_this.parents('.bottom-links').siblings('#card_product_info').attr('data-product-discount')){
        var product_discount = parseInt(_this.parents('.bottom-links').siblings('#card_product_info').attr('data-product-discount'));
      }
      $('.quick-buy-modal-block').attr('data-product-handle', product_data.handle)
      $('.quick-buy-modal-block').attr('data-modal-index', product_data.id)
      $('.quick-buy-modal-block .modal-title .product_title').text(product_data.title);
      $('.quick-buy-modal-block .modal-title img').attr('src', product_data.featured_image);
      $('.quick-buy-modal-block .product-form__quantity input.quantity__input').val("1");
      
      quickBuyModalButtonStatus(product_data.variants[0].available, product_data.variants[0].id);
      
      if(product_discount > 1){
        var p_price = (product_data.variants[0].price * product_discount) / 100;
        var d_price = product_data.variants[0].price - p_price;
        
          //$('.quick-buy-modal-block .modal-title .modal-price-wrap').html('<span class="normal-price">' + Shopify.formatMoney(product_data.variants[0].price, money_format) + '</span><span class="discount-price">' + Shopify.formatMoney(d_price, money_format) + '</span>');
          $('.quick-buy-modal-block .modal-title .modal-price-wrap').html('<span class="normal-price">' + Shopify.formatMoney(product_data.variants[0].price, money_format) + '</span>');
          $('.quick-buy-modal-block .modal-detail .offer-info.new-price span.new-price').html(Shopify.formatMoney(d_price, money_format));
          $('.quick-buy-modal-block .modal-detail .offer-info.discount-message p').html(discount_message);
          $('.quick-buy-modal-block .modal-detail .offer-info').removeClass('hidden');
      }else{
        if(product_data.variants[0].compare_at_price == null || product_data.variants[0].compare_at_price <= product_data.variants[0].price){
          $('.quick-buy-modal-block .modal-title .modal-price-wrap').html('<span class="discount-price">' + Shopify.formatMoney(product_data.variants[0].price, money_format) + '</span>');
        }else{
          $('.quick-buy-modal-block .modal-title .modal-price-wrap').html('<span class="normal-price">' + Shopify.formatMoney(product_data.variants[0].compare_at_price, money_format) + '</span><span class="discount-price">' + Shopify.formatMoney(product_data.variants[0].price, money_format) + '</span>');
        }
      }
      
      var select_html = [];
      var options = [[], [], []];
      var variant_select_html = '<select id="product_variant_dropdown" style="display:none;">';
      for(var j = 0; j < product_data.variants.length; j++){
        
        if(product_data.variants[j].option1 != null || product_data.variants[j].option1 != "null" || product_data.variants[j].option1 != undefined || product_data.variants[j].option1 != "undefined" || product_data.variants[j].option1 != '' ){
          options[0].push(product_data.variants[j].option1)
        }
        
        if(product_data.variants[j].option2){
          options[1].push(product_data.variants[j].option2)
        }
         
        if(product_data.variants[j].option3 != null || product_data.variants[j].option3 != "null" || product_data.variants[j].option3 != undefined || product_data.variants[j].option3 != "undefined" || product_data.variants[j].option3 != '' ){
          options[2].push(product_data.variants[j].option3)
        }
        var variant_image = null;
        if(product_data.variants[j].featured_image){
          variant_image = product_data.variants[j].featured_image.src
        }
        
        variant_select_html = variant_select_html + '<option value="' + product_data.variants[j].title + '" data-id="'+ product_data.variants[j].id +'" data-price="'+ product_data.variants[j].price +'" data-compare-price="'+ product_data.variants[j].compare_at_price +'" data-discount = "' + product_discount + '" data-availability="'+ product_data.variants[j].available +'" data-option1="' + product_data.variants[j].option1 + '" data-option2="' + product_data.variants[j].option2 + '" data-option3="' + product_data.variants[j].option3 + '" data-image="' + variant_image + '">' + product_data.variants[j].title + '</option>';
      }
      variant_select_html = variant_select_html + '</select>';
      
      for(var i = 0; i < product_data.options.length; i++){
        if(product_data.options[i] == 'mlveda_country'){
          select_html[i] = '<div class="product-form__input product-form__input--dropdown hidden">'
        }else{
          select_html[i] = '<div class="product-form__input product-form__input--dropdown">'
        }
          select_html[i] = select_html[i] + '<label class="form__label" for="Option-'+ i +'">'+ product_data.options[i] +':</label>'
          select_html[i] = select_html[i] + '<div class="select"><select id="Option-'+ i +'" class="select__select" name="options['+ product_data.options[i] +']">'
          options[i] = options[i].filter((item, index) => options[i].indexOf(item) === index)
          for(var k = 0; k < options[i].length; k++){
            select_html[i] = select_html[i] + '<option value="'+ options[i][k] +'">'+ options[i][k] +'</option>'
          }
          select_html[i] = select_html[i] + '</select><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg>'
          select_html[i] = select_html[i] + '</div></div>'
        
      }
      var select_html_string = select_html.join('');
      $('.quick-buy-modal-block .quick-buy-modal-body .modal-select').html(select_html_string + variant_select_html)
      $('.quick-buy-modal-block .unlimited-text a.view-detail').attr('href', handle+'/products/'+product_data.handle);

      $('body').addClass("modal-open");

      $('.quick-buy-modal-block .quick-buy-modal-body quantity-input input.quantity__input').removeAttr('max');
      var quantity_limit = _this.parents('.bottom-links').siblings('#card_product_info').attr('data-quantity-limit');
      if(quantity_limit){
        $('.quick-buy-modal-block .quick-buy-modal-body quantity-input input.quantity__input').attr('max', parseInt(quantity_limit));
      }

      viewItemDL(product_data, 1, 0)
    });

    $(document).on('change', `.quick-buy-modal-block .product-form__input--dropdown .select__select`, function(){

      var _selected_option = $(this).val();
      
      var var_id = modalSelectedVariant();
      var variant_title = getVariantTitle();
      var var_availability = $('.quick-buy-modal-block #product_variant_dropdown option[value = "'+variant_title+'"]').attr('data-availability')
      quickBuyModalButtonStatus(var_availability, var_id);
      if(var_id){
        changeItemDL(var_id)
      }
    });

    $(document).on('click', `.quick-buy-modal-block .modal-btn-block .enable_cart`, function(){
        var _this = $(this)
        var var_id = parseFloat(modalSelectedVariant());
        var qty = parseInt($('.quick-buy-modal-block .product-form__quantity .quantity__input').val())
        const data = {
        	items: [
            {
               quantity: qty,
               id: var_id
            }
          ]
        };
        var product_handle = [];
        product_handle.push($('.quick-buy-modal-block').attr('data-product-handle'));
        if($(this).hasClass('add_to_cart_btn')){
          ajaxCart(data, 'modalAdd', _this, product_handle)
        }else{
          ajaxCart(data, 'quickAdd', _this, product_handle)
        }
        
    });

    // frequently product section js 
    
    $(document).on('change', `#upsell-products .frequently-right .custom-select select`, function(){
      var _this = $(this);
      var _this_inventory = parseFloat(_this.find('option:selected').attr('data-inventory'));
      if(_this_inventory < 1){
        _this.parents(".select-checkbox").find('input[type = checkbox]').prop('checked', false);
        _this.parents(".select-checkbox").find('input[type = checkbox]').attr('disabled', true);
      }else{
        _this.parents(".select-checkbox").find('input[type = checkbox]').prop('checked', true);
        _this.parents(".select-checkbox").find('input[type = checkbox]').removeAttr('disabled');
      }
      updateUpsellData();
    });
    $(document).on('click', `#upsell-products .frequently-right .select-checkbox .checkmark`, function(){
      setTimeout(function(){
      updateUpsellData();
      },200)
    });
    $(document).on('click', `#upsell-products .frequently-right .upsell_add_to_cart:not(.disabled)`, function(){
      var variant_arr = []
      var product_handles = []
      var __this = $(this);
      $("#upsell-products .frequently-right .select-checkbox").each(function(){
        
        var _this = $(this);
        if(_this.find('input[type = checkbox]').is(':checked')){
          let var_obj = {
            quantity: 1,
            id: parseFloat(_this.find('select option:selected').attr('data-id'))
          };
          variant_arr.push(var_obj)
          product_handles.push(_this.attr('data-product-handle'))
        }
      });
      const data = {
      	items: variant_arr
      };
      ajaxCart(data, 'modalAdd', __this, product_handles);
    }); 

    // Search on blog page 
    if($("#blog-search").length > 0){
      var url = window.location.href;
      if (url.includes('?search=')){
        var urlArr = url.split("?search=")
        var search_term = urlArr[1].toLowerCase()
        if(search_term){
          $('.blog-search-form input[type=search]').val(search_term)
          $(".article-search-item").filter(function() {
            $(this).toggle($(this).text().toLowerCase().indexOf(search_term) > -1)
          });
        }else{
          location.href = urlArr[0]
        }
      }
    }

    $(document).on('change', `.quick-buy-modal-block .product-form__quantity .quantity input.quantity__input`, function(){
      var var_id = modalSelectedVariant();
      if(var_id){
        var pro_id = $('.quick-buy-modal-block').attr('data-modal-index')
        var product = JSON.parse($('input[type = hidden][data-index = '+pro_id+']').attr('data-product'));
        var qty = parseInt($('.quick-buy-modal-block input.quantity__input').val())
        for(var i = 0; i < product.variants.length; i++){
          if(parseFloat(product.variants[i].id) == parseFloat(var_id)){
            variant_index = i
          }
        }
      
        viewItemDL(product, qty, variant_index)
      }
    });

    $(document).on('change', `.pdp-main-wrapper .product-form__quantity .quantity input.quantity__input`, function(){
      var qty = parseInt($('.pdp-main-wrapper .product-form__quantity .quantity .quantity__input').val());
      var regular_price = parseInt($('.pdp-main-wrapper .price').attr('data-price'));
      $('.pdp-main-wrapper .price .price-item--regular').html(Shopify.formatMoney(regular_price*qty, money_format));
      //sticky bar price 
      $('.sticky-add-to-cart-wrapper .sticky-bar-price [data-price-regular]').html(Shopify.formatMoney(regular_price*qty, money_format));

      if ($('.pdp-main-wrapper .custom-discount-price').length > 0){
        const p_discount = parseFloat($('.pdp-main-wrapper .custom-discount-price .offer-info .price-item--sale').attr('data-discount'));
        const d_price = (regular_price * p_discount) / 100.0;
        const discounted_price = regular_price - d_price;
        $('.pdp-main-wrapper .price .custom-discount-price .offer-info .price-item--sale').html(Shopify.formatMoney(discounted_price*qty, money_format));
        //sticky bar price 
        $('.sticky-add-to-cart-wrapper .sticky-bar-price .price-sale').html(Shopify.formatMoney(discounted_price*qty, money_format));
      }else{
        if($('.pdp-main-wrapper .price').attr('data-compare-price')){
          var compare_price = parseInt($('.pdp-main-wrapper .price').attr('data-compare-price'));
          $('.pdp-main-wrapper .price .price-item--sale').html(Shopify.formatMoney(regular_price*qty, money_format));
          $('.pdp-main-wrapper .price .price-item--regular').html(Shopify.formatMoney(compare_price*qty, money_format));
          //sticky bar price 
          $('.sticky-add-to-cart-wrapper .sticky-bar-price .price-sale').html(Shopify.formatMoney(regular_price*qty, money_format));
          $('.sticky-add-to-cart-wrapper .sticky-bar-price [data-price-regular]').html(Shopify.formatMoney(compare_price*qty, money_format));
        }
      }
      
      if(!$(this).hasClass('unavailable')){
        var selected_variant_id = $('.pdp-main-wrapper form[data-type=add-to-cart-form] input[name=id]').val()
        PDPviewItemDL(selected_variant_id)
      }
      
    });

    // Quick buy JS on pdp

    /*$(document).on('click', `.pdp-main-wrapper .product_quick_buy`, function(){
      $(this).attr('disabled', true)
      handleQuickBuy(this);
    });

    $(document).on('click', `.sticky-add-to-cart-wrapper .product_quick_buy`, function(){
      $(this).attr('disabled', true);
      const pdpButton = $('.pdp-main-wrapper .product_quick_buy');
      if (pdpButton.length) {
        handleQuickBuy(pdpButton.get(0));
      }
    });*/
    $(document).on('click', `.sticky-add-to-cart-wrapper .product-form__submit button[name=add]`, function(e){
      e.preventDefault();
      var _this = $(this);
      _this.attr("aria-disabled", true);
      _this.addClass("loading");
      _this.find(".loading-overlay__spinner").removeClass("hidden");
      
      var form = $('.pdp-main-wrapper form[data-type=add-to-cart-form]');
        $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: form.serialize(),
        dataType: 'json',
        success: function(cart) {
          getCart()
          //Open upCart drawer from app
          if (typeof upcartOpenCart === 'function') {
            upcartOpenCart();
          }
        },
        error: function(err) {
          console.log(err);
          handlePDPErrorMessage(err);
        }, 
        complete: function() {
          _this.removeAttr("aria-disabled");
          _this.removeClass("loading");
          _this.find(".loading-overlay__spinner").addClass("hidden");
          
        }
      });
    });
});

// Restrict quantity limit if exeed from the limit
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.quantity__input').forEach(input => {
    input.addEventListener('input', function () {
      const max = parseInt(this.max, 10);
      const value = parseInt(this.value, 10);

      if (max && value > max) this.value = max;
      if (value < 1) this.value = 1;
    });
  });
});

/*function handleQuickBuy(button, thisButton) {
  var form = $(button).closest('form[data-type=add-to-cart-form]');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: form.serialize(),
    dataType: 'json',
    success: function(res) {
      location.href = '/checkout';
    },
    error: function(err) {
      console.log(err);
      handlePDPErrorMessage(err);
    }
  });
}*/

function handlePDPErrorMessage(err){
    const isPDP = document.querySelector('.pdp-main-wrapper');
    if (!isPDP) return;
    const errorMessageWrapper = isPDP.querySelector(".product-form__error-message-wrapper.quantity-error");
    const errorMessageEl = errorMessageWrapper?.querySelector(".product-form__error-message");
    const errorMessage = err.responseJSON.message;

    if (!errorMessageWrapper || !errorMessageEl) return;

    errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
    errorMessageWrapper.style.transition = 'opacity 200ms';
    errorMessageWrapper.style.opacity = '1';
    setTimeout(function(){

        errorMessageWrapper.style.opacity = '0';
        setTimeout(() => {
            errorMessageWrapper.toggleAttribute("hidden", errorMessage);
            errorMessageWrapper.style.removeProperty('transition');
            errorMessageWrapper.style.removeProperty('opacity');
        }, 300);
    }, 10000);

    if (errorMessage) {
      errorMessageEl.textContent = errorMessage;
      //$('html, body').animate({ scrollTop: 0 }, 500);
      window.scrollTo({
        top: 500,
        behavior: "smooth"
      });
    }
}

function getVariantTitle(){
    var variant_title;
    if($('.quick-buy-modal-block .product-form__input--dropdown .select__select#Option-0').length > 0){
      var option0_val = $('.quick-buy-modal-block .product-form__input--dropdown .select__select#Option-0 option:selected').val();
      variant_title = option0_val;
    }
    if($('.quick-buy-modal-block .product-form__input--dropdown .select__select#Option-1').length > 0){
      var option1_val = $('.quick-buy-modal-block .product-form__input--dropdown .select__select#Option-1 option:selected').val();
      variant_title = option0_val + " / " + option1_val;
    }
    if($('.quick-buy-modal-block .product-form__input--dropdown .select__select#Option-2').length > 0){
      var option2_val = $('.quick-buy-modal-block .product-form__input--dropdown .select__select#Option-2 option:selected').val();
      variant_title = option0_val + " / " + option1_val + " / " + option2_val;
    }
    return variant_title;
  
}

function modalSelectedVariant(){
      var qty = parseInt($('.quick-buy-modal-block .product-form__quantity .quantity .quantity__input').val());
     
      var variant_title = getVariantTitle();
      
      var var_id = $('.quick-buy-modal-block #product_variant_dropdown option[value = "'+variant_title+'"]').attr('data-id')
      $('.quick-buy-modal-block .modal-price-wrap').html('');
      var variant_image = $('.quick-buy-modal-block #product_variant_dropdown option[value = "'+variant_title+'"]').attr('data-image');
      var regular_price = parseInt($('.quick-buy-modal-block #product_variant_dropdown option[value = "'+variant_title+'"]').attr('data-price'))
      var compare_price = parseInt($('.quick-buy-modal-block #product_variant_dropdown option[value = "'+variant_title+'"]').attr('data-compare-price'))
      var discount = parseInt($('.quick-buy-modal-block #product_variant_dropdown option[value = "'+variant_title+'"]').attr('data-discount'))
  
      if(variant_image != null && variant_image != 'null' && variant_image != 'undefined' && variant_image != undefined){
        $('.quick-buy-modal-block .modal-title img').attr('src', variant_image);
      }
      if(discount > 0){
        var p_price = (regular_price * discount) / 100;
        var discount_price = regular_price - p_price;
        //$('.quick-buy-modal-block .modal-price-wrap').html('<span class="normal-price">'+Shopify.formatMoney(regular_price*qty, money_format)+'</span><span class="discount-price">'+Shopify.formatMoney(discount_price*qty, money_format)+'</span>')
        $('.quick-buy-modal-block .modal-price-wrap').html('<span class="normal-price">'+Shopify.formatMoney(regular_price*qty, money_format)+'</span>');
        $('.quick-buy-modal-block .modal-detail .offer-info.new-price span.new-price').html(Shopify.formatMoney(discount_price*qty, money_format));
      }else{
        if(compare_price && compare_price > regular_price){
          $('.quick-buy-modal-block .modal-price-wrap').html('<span class="normal-price">'+Shopify.formatMoney(compare_price*qty, money_format)+'</span><span class="discount-price">'+Shopify.formatMoney(regular_price*qty, money_format)+'</span>')
        }else{
          $('.quick-buy-modal-block .modal-price-wrap').html('<span class="discount-price">'+Shopify.formatMoney(regular_price*qty, money_format)+'</span>')
        }
      }
  
      return var_id;
}
function ajaxCart(data, btn, _this, product_handle){
  
      _this.parents('.ajax-cart-wrapper').attr('aria-disabled', true);
      _this.parents('.ajax-cart-wrapper').addClass('loading');
      _this.parents('.ajax-cart-wrapper').find('.loading-overlay__spinner').removeClass('hidden');
      var ajaxFlag = 0;
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function(cart) { 
          dataLayerAddToCart(data, product_handle)
          if(btn == 'modalAdd'){
            setTimeout(function(){
              
              _this.parents('.ajax-cart-wrapper').removeClass('loading');
              _this.parents('.ajax-cart-wrapper').find('.loading-overlay__spinner').addClass('hidden');
              _this.parents('.ajax-cart-wrapper').find('.check-icon').removeClass('hidden');
              _this.parents('.ajax-cart-wrapper').addClass('checkmark');
              
              //Open upCart drawer from app
              if (typeof upcartOpenCart === 'function') {
                upcartOpenCart();
              }
            },500)
            setTimeout(function(){
              _this.parents('.ajax-cart-wrapper').removeAttr('aria-disabled');
              _this.parents('.ajax-cart-wrapper').find('.check-icon').addClass('hidden');
              _this.parents('.ajax-cart-wrapper').removeClass('checkmark');
              getCart()
              $('.quick-buy-modal-block .modal-header .close-modal').trigger('click')
              
            },1300)            
            
          }else{
            location.href = '/checkout'
          }
        },
        error: function(err) { 
          const errorBlock = _this.parents('.quick-buy-modal-block').find('.quick-buy-error');
          const errorText = errorBlock.find('p');

          errorText.text(err.responseJSON?.message || "Something went wrong.");
          errorBlock.stop(true, true).hide().removeAttr('hidden').fadeIn(200);

          setTimeout(function () {
            errorBlock.fadeOut(400, function () {
              $(this).attr('hidden', true);
            });
          }, 10000);

          _this.parents('.ajax-cart-wrapper').removeClass('loading');
          _this.parents('.ajax-cart-wrapper').find('.loading-overlay__spinner').addClass('hidden');
          _this.parents('.ajax-cart-wrapper').removeAttr('aria-disabled');
        }
      });
}

function getCart(){
  
      jQuery.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) { 
          $('.header__icon .cart-count-bubble span:first-child').text(cart.item_count)
          $('.header__icon .cart-count-bubble span.visually-hidden').text(cart.item_count+" items")
        },
        error: function(err) { 
          console.log(err)
        }
      });
}

function updateUpsellData() {
    var select = $("#upsell-products .frequently-right .select-checkbox");
    var total_price = 0;
    var count = 0
    for (var i = 0; i < select.length; i++) {
      var _this_price = parseFloat($(select[i]).find('select option:selected').attr('data-price'));
      
      
      var _this_index = parseFloat($(select[i]).attr('data-select-index'));
      $('#upsell-products .frequently-left .product-item[data-product-index = '+ _this_index +'] .price .new-price').html(Shopify.formatMoney(_this_price, money_format));
      if($(select[i]).find('input[type = checkbox]').is(":checked")){
        total_price = total_price + _this_price;
        count = count + 1;
      }
    }
    $('#upsell-products .frequently-right .total_upsell_price').html(Shopify.formatMoney(total_price, money_format))
    if(count > 0){
      $('#upsell-products .upsell_add_to_cart').text('ADD '+ count +' ITEMS TO BASKET')
      $('#upsell-products .upsell_add_to_cart').attr('title', 'ADD '+ count +' ITEMS TO BASKET');
      $('#upsell-products .upsell_add_to_cart').removeClass('disabled');
    }else{
      $('#upsell-products .upsell_add_to_cart').text('Select a Product')
      $('#upsell-products .upsell_add_to_cart').attr('title', 'Select a Product');
      $('#upsell-products .upsell_add_to_cart').addClass('disabled');
    }
}

function quickBuyModalButtonStatus (variant_availability, var_id){
    if(var_id){
        if(variant_availability == true || variant_availability == 'true'){
            $('.quick-buy-modal-block .modal-btn-block .add_to_cart_btn').text('ADD TO CART')
            $('.quick-buy-modal-block .modal-btn-block .add_to_cart_btn').attr("title", "ADD TO CART")
            $('.quick-buy-modal-block .modal-btn-block .add_to_cart_btn,.checkout_btn').addClass("enable_cart")
            $('.quick-buy-modal-block .modal-btn-block .add_to_cart_btn,.checkout_btn').removeClass("disabled")
        }else{
            $('.quick-buy-modal-block .modal-btn-block .add_to_cart_btn').text('Sold Out')
            $('.quick-buy-modal-block .modal-btn-block .add_to_cart_btn').attr({"title":"Sold Out"})
            $('.quick-buy-modal-block .modal-btn-block .add_to_cart_btn,.checkout_btn').removeClass("enable_cart")
            $('.quick-buy-modal-block .modal-btn-block .checkout_btn,.add_to_cart_btn').addClass("disabled")
        }
    }else{
      $('.quick-buy-modal-block .modal-btn-block .add_to_cart_btn').text('Unavailable')
      $('.quick-buy-modal-block .modal-btn-block .add_to_cart_btn').attr({"title":"Unavailable"})
      $('.quick-buy-modal-block .modal-btn-block .add_to_cart_btn,.checkout_btn').removeClass("enable_cart")
      $('.quick-buy-modal-block .modal-btn-block .checkout_btn,.add_to_cart_btn').addClass("disabled")
    }
  
}

function clearPayPriceUpdate(){
  var offer_price_str = $('.custom-discount-price .offer-info .price-item').text().trim();
  var offer_price = parseFloat(offer_price_str.replace(/[^0-9.]/g, ''))
        
  const clearpayInterval = setInterval(function(){  
    if($('.shopify-app-block square-placement').length > 0){
      
      var app_block = $('.shopify-app-block square-placement');
      if(app_block[0].shadow && app_block[0].brandNameLower == "clearpay"){
        $(app_block).attr('data-amount', offer_price);
        clearInterval(clearpayInterval);
      }
    }
  }, 300);
  
  setTimeout(function(){
    clearInterval(clearpayInterval);
  }, 10000)
}